import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from "components/anexo/AnexoPanel";
import { Label } from "components/input/Label";
import Usuario from "model/administracao/cadastro/Usuario";
import HelpdeskChamado from "model/helpdesk/HelpdeskChamado";
import HelpdeskTramite from "model/helpdesk/HelpdeskTramite";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import HelpdeskTramiteService from "service/helpdesk/HelpdeskTramiteService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";

const helpdeskTramiteService = new HelpdeskTramiteService();
const usuarioLogadoService = new UsuarioLogadoService();

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    helpdeskChamado: HelpdeskChamado;
    onConfirm: () => void;
}

export default function HelpdeskTramiteCadastroModal(props: Props) {

    const { control, setFocus, clearErrors, setError, register, formState: { errors } } = useForm();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading} = useLoadingContext();

    const [helpdeskTramite, setHelpdeskTramite] = useState<HelpdeskTramite>(new HelpdeskTramite());
    const [anexos, setAnexos] = useState<any[]>([])
    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);

    useEffect(() => {
        setHelpdeskTramite({
            id: 0,
            key: "",
            data: new Date(),
            sequencial: 0,
            resposta: "",
            usuario: new Usuario(),
            chamado: props.helpdeskChamado,
            arquivos: [],
        });
    }, [props.visible])

    function validar() {
        if (!helpdeskTramite.resposta) {
            setError("resposta", { type: "manual", message: "Resposta é obrigatória" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    return (
        <>
            <Dialog header="Trâmite" visible={props.visible} baseZIndex={500} style={{ width: '50vw' }} onHide={() => props.setVisible(false)}>
                <div className="row">
                    <Label className="col col-sm-12" obrigatorio>Resposta</Label>
                    <div className="col-sm-12">
                        <InputTextarea value={helpdeskTramite.resposta || ""} style={{ width: '100%' }}
                            className={errors.resposta ? "p-invalid" : ""}
                            {...register("resposta", {
                                onChange: (e) => {
                                    setHelpdeskTramite({ ...helpdeskTramite, resposta: e.target.value })
                                    clearErrors("resposta")
                                }
                            })} />
                    </div>
                    {errors.resposta && errors.resposta.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.resposta?.message as string}</span> : null}
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <AnexoPanel
                            novosAnexos={anexos} onChangeNovosAnexos={(e: any) => setAnexos(e)}
                            arquivos={helpdeskTramite.arquivos} onChange={(e) => {
                                setHelpdeskTramite({ ...helpdeskTramite, arquivos: e })
                            }}
                            collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <Button label="Confirmar" style={{ marginRight: 30 }} onClick={() => {
                            if(validar()) {
                                startLoading();
                                helpdeskTramiteService.incluir(getFormData("helpdeskTramite", helpdeskTramite, anexos)).then(() => {
                                    props.setVisible(false);
                                    stopLoading();
                                    props.onConfirm();
                                }).catch(e => {
                                    stopLoading();
                                    console.error(e);
                                    if (e && e.data && e.data.message) {
                                        msgErro("Trâmite", e.data.message);
                                    } else {
                                        msgErro("Trâmite", 'Ocorreu um erro ao gerar o Trâmite, tente novamente!');
                                    }
                                });
                            } else {
                                msgAlerta("Trâmite", 'Favor, preencher todos os campos obrigatórios');
                            }
                        }} />
                    </div>
                </div>
            </Dialog>
        </>
    )
}